import { Injectable } from '@angular/core';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {Observable} from 'rxjs/Observable';
import {ServiceName} from './Service';

export enum ErrorType {
  HTTP,
  AUTH,
  SERVICE,
  SUBMIT,
  UNHANDLED
}

export interface ErrorEvent {
  type: ErrorType;
  error: Error;
}




@Injectable()
export class ErrorService {

  private _subject: BehaviorSubject<ErrorEvent> = new BehaviorSubject<ErrorEvent>(null);
  public readonly onError: Observable<ErrorEvent> = this._subject.asObservable();
  constructor() { }

  public push( error: Error, type?: ErrorType ) {
    if (!type ) {
      type = ErrorType.UNHANDLED;
    }
    console.log('ErrorService.push', {type: ErrorType[type], error: error});
    this._subject.next({type: type, error: error});
  }

}

ServiceName.add('ErrorService', ErrorService);



// WEBPACK FOOTER //
// ./src/app/core/services/error.service.ts